/** ログインの画面に出す決まった案内。値の文言は画面の側に持ち、URL の文字列は画面に出さない。 */
export type PatientLoginNotice = "expired" | "signed-out";

export const PATIENT_LOGIN_PATH = "/patient/login";

/** ログインの後と、ログイン済みでログインの画面を開いたときの行き先（戻り先の URL は持たない）。 */
export const PATIENT_HOME_PATH = "/patient/home";

export function patientLoginPath(notice?: PatientLoginNotice): string {
  return notice
    ? `${PATIENT_LOGIN_PATH}?notice=${encodeURIComponent(notice)}`
    : PATIENT_LOGIN_PATH;
}

/** 画面の URL が患者のページか（API のトークンの選び方と 401 の扱いを、要求を出した画面で決める）。 */
export function isPatientPagePath(pathname: string): boolean {
  return pathname.startsWith("/patient/");
}
